function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useContext } from "react";
import { BreakpointsContext } from "../../Breakpoints/BreakpointsProvider";
import Col from "../../Col";
import Row from "../../Row";
import { injectTestId } from "@cvent/nucleus-test-automation";
import useStyle from "../IllustrationNotice/IllustrationNotice.style";
export var IllustrationContent = function(param) {
    var testID = param.testID, isRtl = param.isRtl, children = param.children;
    var ref = useStyle(isRtl), bodyDefaultStyles = ref.bodyDefaultStyles, bodySmallStyles = ref.bodySmallStyles;
    var ref1 = useContext(BreakpointsContext), isDefaultSize = ref1.isDefaultSize, isS = ref1.isS;
    return _jsx(Row, {
        margin: {
            top: 16,
            bottom: 32
        },
        justifyContent: "center",
        children: _jsx(Col, {
            children: _jsx("div", _objectSpread({
                css: isDefaultSize || isS ? bodySmallStyles : bodyDefaultStyles
            }, injectTestId(testID), {
                children: children
            }))
        })
    });
};
